import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Alert
} from 'reactstrap'
import FileSaver from 'file-saver'
import NotificationService from 'services/NotificationService'

import api from '../api'
import './Export.scss'

class ExportIncidents extends Component {

    static propTypes = {
        organisationId: PropTypes.number,
        startdate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        enddate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
    }

    state = {
        requested: false,
        success: false,
        error: null
    }

    handleClick = async() => {
        const { organisationId, startdate, enddate } = this.props

        try {
            const response = await api.getIncidentsExport(organisationId, startdate, enddate)
            if (response && response.data) {
                FileSaver.saveAs(response.data, 'incidenten.xlsx')
                this.setState({
                    requested: true,
                    success: true
                })
            } else {
                this.setState({
                    requested: true,
                    success: false
                })
            }
        } catch (err) {
            this.setState({
                requested: false
            }, () =>
                NotificationService.notifyError({
                    title: err.message || 'Fout',
                    message: 'Er heeft een fout opgetreden tijdens het verwerken van het verzoek.'
                })
            )
        } finally {
            window.setTimeout(() => {
                this.setState({
                    requested: false,
                    success: false
                })
            }, 10000) // reset after 10 seconds
        }
    }

    render() {
        const isValid = new Date(this.props.startdate) <= new Date(this.props.enddate)

        let color = this.state.requested ?
            this.state.success ? 'success' : 'danger'
            : 'light'

        if (this.state.error) {
            color = 'danger'
        }

        return (
            <div>
                <Button
                    disabled={ !isValid }
                    onClick={ this.handleClick }
                    color={ color }
                >
                Export incidenten
                </Button>
                { this.state.error && (
                    <div className="mt-1">
                        <Alert color="danger">{ this.state.error }</Alert>
                    </div>
                ) }
            </div>
        )
    }
}

export default ExportIncidents
